import { Controller } from "@hotwired/stimulus"

const MOBILE_MAX_WIDTH = 768

export default class extends Controller {
  static values = {
    flag: String,
    variant: { type: String, default: "test" },
  }

  connect() {
    this.unsubscribeFeatureFlags = posthog.onFeatureFlags(() => this.collapseIfActive())
  }

  collapseIfActive() {
    if (window.innerWidth >= MOBILE_MAX_WIDTH) return
    if (posthog.getFeatureFlag(this.flagValue) === this.variantValue) {
      this.element.removeAttribute("open")
    }
  }

  disconnect() {
    this.unsubscribeFeatureFlags?.()
  }
}
